const PASSWORD_VALIDATION_CONFIG = {
  allowedSpecialChars: '!"§$%&/()=@*+-?',

  passwordNeedsLowerCase: true,
  passwordNeedsUpperCase: false,
  passwordNeedsSpecialChar: true,
  passwordNeedsNumber: true,
  passwordMinLength: 8
};

const ESCAPED_ALLOWED_SPECIAL_CHARS = escapeString(PASSWORD_VALIDATION_CONFIG.allowedSpecialChars);

const allAllowedCharsAndLengthRegExp = createAllAllowedCharsAndLengthRegExp();
const allowedSpecialCharsRegExp = new RegExp(`[${ESCAPED_ALLOWED_SPECIAL_CHARS}]`);
const lowerCaseCharRegExp = new RegExp('[abcdefghijklmnopqrstuvwxyz]');
const upperCaseCharRegExp = new RegExp('[ABCDEFGHIJKLMNOPQRSTUVWXYZ]');
const numberRegExp = new RegExp('[0-9]');

export function isPasswordValid(value: string): boolean {
  if (!value) {
    return false;
  }
  let result =
    // mindestens 8 Zeichen, nur erlaubte Zeichen
    // /^[abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNONPQRSTUVWXYZ0-9\!\"\§\$\%\&\/\(\)\=\@\*\+\-\?]{8,}$/.test(value) &&

    checkAllAllowedCharsAndLength(value) &&
    // mindestens ein erlaubter Kleinbuchstabe
    checkLowerCaseChar(value) &&
    // mindestens ein erlaubter Grossbuchstabe
    checkUpperCaseChar(value) &&
    // mindestens eine erlaubte Ziffer
    checkNumber(value) &&
    // mindestens ein erlaubtes Sonderzeichen
    // /[\!\"\§\$\%\&\/\(\)\=\@\*\+\-\?]/.test(value)
    checkSpecialChar(value);

  if (value.length < PASSWORD_VALIDATION_CONFIG.passwordMinLength) {
    result = false;
  }
  return result;
}

export function passwordValidationMessage(viewValue: string, modelValue?: any): string {
  const value = modelValue || viewValue;

  if (!value) {
    return 'Eingabe erforderlich';
  }

  if (!checkLowerCaseChar(value)) {
    return 'Es muss zumindest 1 Kleinbuchstabe vorhanden sein';
  }

  if (!checkUpperCaseChar(value)) {
    return 'Es muss zumindest 1 Grossbuchstabe vorhanden sein';
  }

  if (!checkNumber(value)) {
    return 'Es muss zumindest 1 Zahl vorhanden sein';
  }

  if (!checkSpecialChar(value)) {
    // Zeichen werden fuer die Meldungsausgabe mit einem blank aufgefuellt (fuer bessere Lesbarkeit)
    const chars = PASSWORD_VALIDATION_CONFIG.allowedSpecialChars.split('').join(' ');
    return `Es muss zumindest 1 Sonderzeichen vorhanden sein (${chars})`;
  }

  if (value.length < PASSWORD_VALIDATION_CONFIG.passwordMinLength) {
    return `Das Passwort ist zu kurz (mindestens ${PASSWORD_VALIDATION_CONFIG.passwordMinLength} Zeichen)`;
  }

  if (!checkAllAllowedCharsAndLength(value)) {
    return 'Das Passwort enthält ungültige Sonderzeichen';
  }

  return '';
}

function checkAllAllowedCharsAndLength(value: string): boolean {
  return !PASSWORD_VALIDATION_CONFIG.passwordNeedsSpecialChar || allAllowedCharsAndLengthRegExp.test(value);
}

function checkLowerCaseChar(value: string): boolean {
  return !PASSWORD_VALIDATION_CONFIG.passwordNeedsLowerCase || lowerCaseCharRegExp.test(value);
}

function checkUpperCaseChar(value: string): boolean {
  return !PASSWORD_VALIDATION_CONFIG.passwordNeedsUpperCase || upperCaseCharRegExp.test(value);
}

function checkNumber(value: string): boolean {
  return !PASSWORD_VALIDATION_CONFIG.passwordNeedsNumber || numberRegExp.test(value);
}

function checkSpecialChar(value: string): boolean {
  return !PASSWORD_VALIDATION_CONFIG.passwordNeedsSpecialChar || allowedSpecialCharsRegExp.test(value);
}

function escapeString(value: string): string {
  let escapedString = '';
  for (const char of value) {
    escapedString = escapedString + '\\' + char;
  }

  return escapedString;
}

function createAllAllowedCharsAndLengthRegExp(): RegExp {
  return new RegExp(
    `^[abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNONPQRSTUVWXYZ0-9${ESCAPED_ALLOWED_SPECIAL_CHARS}]{${PASSWORD_VALIDATION_CONFIG.passwordMinLength},}$`
  );
}
